// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__ZFg4T","title":"Images90_title__1GnbH","images":"Images90_images__3pOVU"};